// eslint-disable-next-line max-statements
(function ($) {

  var maxRatingCommentLength = 1024;
  var isTranslated = $('.article-rating-container').attr('data-mt');

  function promptRatingComments(wasHelpful) {
    if (wasHelpful) {
      $('.rating-feedback-yes').show();
    } else {
      $('.rating-feedback-no').show();
    }
    $('.rating-comments').show();
    $('#rating-submit').show();
    $('#rating-cancel').show();
  }

  function hideRatingComments() {
    $('.rating-feedback-yes').hide();
    $('.rating-feedback-no').hide();
    $('.rating-comments').hide();
    $('#rating-submit').hide();
    $('#rating-cancel').hide();
  }

  function showThankYou() {
    $('.rating-feedback-ty').show();
  }

  function stripTags(text) {
    return text.replace(/(<([^>]+)>)/ig, '');
  }

  function getRatingValue() {
    var ratingValue = null;
    if ($('.rating-feedback-yes').is(':visible')) {
      ratingValue = true;
    } else if ($('.rating-feedback-no').is(':visible')) {
      ratingValue = false;
    }
    return ratingValue;
  }

  function getShopperId() {
    var infoIdp = ux.utils.cookie.get('info_idp');
    if (infoIdp) {
      return JSON.parse(infoIdp).info_shopperId || '';
    }
    return '';
  }

  function addCommentsToVault(comments, helpful) {

    var commentsData = JSON.stringify({
      url: document.location.href,
      comments: comments,
      helpful: helpful,
      shopperId: getShopperId()
    });
    $.ajax({ url: requestContext.hostPath + '/ajax/rating?msg=' +
      encodeURIComponent(commentsData) });
  }

  function sendRatingComments() {
    var ratingValue = getRatingValue();  // must be before hideRatingComments
    hideRatingComments();
    showThankYou();

    var ratingComments = stripTags($('.rating-comments').val());
    if (ratingComments.length > maxRatingCommentLength) {
      ratingComments = ratingComments.substr(0, maxRatingCommentLength);
    }

    if (ratingComments.length === 0) {
      return;
    }

    ux.traffic.custom('notify', 'mcx.help.article.rating.comments', [
      ['url', document.location.href],
      ['helpful', ratingValue],
      ['comments', ratingComments]
    ]);

    addCommentsToVault(ratingComments, ratingValue);
  }

  function cancelRatingComments() {
    hideRatingComments();
    showThankYou();
  }

  function sendArticleRatingEvent(url, wasHelpful) {
    const eid = wasHelpful
      ? 'mcx.help.article.rating-helpful-yes.click'
      : 'mcx.help.article.rating-helpful-no.click';

    ux.traffic.custom('notify', eid, [
      ['url', url],
      ['helpful', wasHelpful],
      ['split', ''],
      ['inapp', gdhelp2.utils.inIframe()],
      ['internal', requestContext.internalRequest],
      ['isTranslated', isTranslated],
      ['plId', requestContext.plId]
    ]);
  }

  function rateArticle(wasHelpful) {
    $('.rating-buttons .rating-button').addClass('disabled');
    var url = document.location.href;

    sendArticleRatingEvent(url, wasHelpful);

    if ($('.rating-comments').length > 0) {
      promptRatingComments(wasHelpful);
    } else {
      showThankYou();
    }
  }

  $('#rating-yes').on('click', function () { rateArticle(true); });
  $('#rating-no').on('click', function () { rateArticle(false); });
  $('#rating-submit').on('click', function () { sendRatingComments(); });
  $('#rating-cancel').on('click', function () { cancelRatingComments(); });

}(jQuery));
